import { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../../../assets';
import { Spacing } from '../../../../../assets/GlobalStyle/Variables';

export const OtherForm: FC = () => {
  return (
    <Wrapper>
      <Title>Ostatní</Title>
      <Desc>
        Placeholder – tento komplement používa „Upřesnění (ostatní)“ v hlavičke. Neskôr sem môžeme
        presunúť špecifické polia.
      </Desc>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(2)};
`;

const Title = styled.h4`
  margin: 0;
  color: ${Colors.black};
`;

const Desc = styled.div`
  color: ${Colors.grey};
`;
